export default __webpack_public_path__ + "static/Atato_logo-2289481194d5b466eb56e68b09ddaf66.png";